import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
import UserAutoComplete from './UserAutoComplete';
import { toMoney } from '../../common/utils';
import { ADD, EDIT, VIEW } from '../../common/common';

const Root = styled(Box)({
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldS': {
            width: '20%',
            marginRight: '10px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .textWapper2': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .itemTitle': {
        marginTop: '30px',
        // marginBottom: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        marginTop: '20px',
        opacity: '0.13',
    },
    '& .line-b': {
        width: '100%',
        marginBottom: '20px',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
    '& .expandBtn': {
        cursor: 'pointer',
        height: '60px',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #F3F3F3',
    },
    '& .closeBtn': {
        cursor: 'pointer',
        height: '60px',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #F3F3F3',
    },
    '& .iconExpand': {
        margin: '0 10px',
        transform: "rotate(-180deg)",
        color: '#9B9B9B',
    },
    '& .iconClose': {
        margin: '0 10px',
        transform: "rotate(0deg)",
        color: '#9B9B9B',
    },
})

class InputList extends Component {
    static defaultProps = {
        data: []
    }
    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
        //数据结构
        // [
        //     {
        //         title: "Date of Referral",
        //         key: "case_type",
        //         value: "2020-11-11",
        //         type: 2,
        //     }, {
        //         title: "Type of case",
        //         key: "case_type",
        //         value: "Immigration-H1B",
        //         type: 1,
        //     }
        // ]
        this.handleChange = this.handleChange.bind(this);
        this.updateMember = this.updateMember.bind(this);
    }
    render() {
        const {
            data
        } = this.state;
        const tfView = (type, title, variable, obj, index) => {
            if (type === 1) {//text
                return <div className="textWapper2" key={index}>
                    <div className="textTitle">{title}</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        value={variable ? variable : ""}
                        onChange={e => this.handleChange(e, index)}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
            } else if (type === 2) {//date
                return <div className="textWapper2" key={index}>
                    <div className="textTitle">{title}</div>
                    <TextField
                        type="date"
                        disabled={this.isDisabled()}
                        className="textField"
                        value={variable ? variable : ""}
                        onChange={e => this.handleChange(e, index)}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
            } else if (type === 3) {//note
                return <div className="textWapper" key={index}>
                    <div className="textTitle">{title}</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="textFieldF"
                        multiline
                        rows="3"
                        value={variable ? variable : ""}
                        onChange={e => this.handleChange(e, index)}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
            } else if (type === 4) {//auto
                return <div className="textWapper" key={index}>
                    <div className="textTitle">{title}</div>
                    <UserAutoComplete
                        disabled={this.isDisabled()}
                        initUser={variable ? variable : null}
                        update={e => this.updateMember(e, index)}
                    />
                </div>
            } else if (type === 5) {//money
                return <div className="textWapper" key={index}>
                    <div className="textTitle">{title}</div>
                    <div className="h">
                        <div>$&nbsp;&nbsp;</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="textFieldS"
                            value={variable ? this.convertDecimal(variable) : '0.00'}
                            onChange={e => this.handleChange(e, index, true)}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                </div>
            } else if (type === 6) {//formula
                return <div className="textWapper" key={index}>
                    <div className="textTitle">{title}</div>
                    <div className="h">
                        <div>Legal Fee: $&nbsp;&nbsp;</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="textFieldS"
                            value={obj.legal_fee ? this.convertDecimal(obj.legal_fee) : '0.00'}
                            onChange={e => this.handleChange(e, index, true, (data, val) => {
                                data.legal_fee = val;
                            })}
                            margin="dense"
                            variant="outlined"
                        />
                        <div>&nbsp;&nbsp;&times;&nbsp;&nbsp;</div>
                        <div>Rate: $&nbsp;&nbsp;</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="textFieldS"
                            value={obj.rate ? obj.rate : 0}
                            onChange={e => this.handleChange(e, index, false, (data, val) => {
                                data.rate = val;
                            })}
                            margin="dense"
                            variant="outlined"
                        />
                        <div>%&nbsp;&nbsp;=&nbsp;&nbsp;<b>$ {toMoney(parseFloat(obj.legal_fee ? obj.legal_fee : 0) * (parseFloat(obj.rate ? obj.rate : 0)) / 100)}</b></div>
                    </div>
                </div>
            } else if (type === 7) {//formula
                return <div className="textWapper" key={index}>
                    <div className="itemTitle">{variable ? variable : ""}</div>
                </div>
            }
        }
        return (
            <Root>
                <div className="flow">
                    {data.map((obj, index) => (
                        tfView(obj.type, obj.title, obj.value, obj, index)
                    ))}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        const { data } = this.props;
        this.setState(() => ({
            data
        }))
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            if (data) {
                this.setState(() => ({
                    data
                }));
            }
        }
    }
    getData() {
        const { data } = this.state;
        return data;
    }
    handleChange(e, index, isDecimal = false, setVal) {
        let value = e.target.value;
        if (isDecimal) {
            if (!value.match(/^[0-9]*\.?[0-9]*$/)) {
                return;
            }
            value = this.convertDecimal(value);
        }
        const { data } = this.state;
        if (setVal) {
            setVal(data[index], value);
        } else {
            data[index].value = value;
        }
        this.setState(() => ({
            data
        }))
    }
    updateMember(member, index) {
        const { data } = this.state;
        data[index].value = member;
        this.setState(() => ({
            data
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    convertDecimal(val) {
        return parseFloat(Math.round(val * 100) / 100).toFixed(2);
    }
}

export default InputList;